<template>
  <div class="Reports">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Reporte</p>
        <div class="b-c">
          <p class="o-b">Rango de fechas</p>
          <p>Selecciona la fecha de inicio y final (Máximo 60 días).</p>
          <div class="row min-h">
            <div class="col-md-4">
            <date-range-picker 
              id="calendarRate"
              style="width: 100%" 
              ref="picker" 
              v-model="dateRange"
              :picker-options="datePickerOptions"
              :locale-data="locale"
              @update="onDateRangeChanged"> 
              <!--    header slot-->
              <div slot="header" slot-scope="header" class="slot right">
                <span v-if="header.in_selection">Selecciona una fecha final</span>
              </div>
              <!--Optional scope for the input displaying the dates --> 
              <div style="width: 100%" slot="input" slot-scope="picker">...</div>
            </date-range-picker>
            <p class="error" v-if="errors != ''">
                <ul>
                  <li>{{ errors }}</li>
                </ul>
              </p>
              <div class="m-top-i">
                <p class="o-b">Fecha de inicio</p>
                <p v-if="dI != ''">{{this.moment(dI).format('DD MMMM YYYY')}}</p>
              </div>

              <div class="m-top-i">
                <p class="o-b">Fecha final</p>
                <p v-if="dF != ''">{{this.moment(dF).format('DD MMMM YYYY')}}</p>
              </div>

              <div class="m-top-i">
                <p class="o-b">Cantidad de días seleccionados</p>
                <p>{{diference}}</p>
              </div>
            </div>
            <div class="info-report col-md-3">
              <div class="sub-t">
                <p class="o-b">Categoría:</p>
                <select class="select-css" v-model="categorySelected" name="category">
                    <option selected value="" >-- Selecciona una opción -- </option>
                    <option v-for="data in categories" :key="data.id" :value="data.id">
                      {{data.name}}
                    </option>
                </select>

              </div>
              <div class="sub-t">
                  <p class="o-b">Servicio:</p> 
                  <select class="select-css" v-model="serviceSelected" name="servicio">
                    <option selected value="" > -- Selecciona una opción -- </option>
                    <optgroup v-for="category in categories" :key="category.id" v-bind:label="category.name">
                      <option v-for="service in services.filter(service => service.category.id == category.id)" :key="service.id" :value="service.id">{{service.name}}</option>
                    </optgroup>
                  </select>
              </div>
              <div class="sub-t">
                  <p class="o-b">Estilista:</p>
                  <select class="select-css" v-model="stylistSelected" name="stylist">>
                    <option selected value="" >-- Selecciona una opción -- </option>
                    <option v-for="dataL in stylists" :key="dataL.id" :value="dataL.id">{{dataL.fullname}}</option>
                  </select>
              </div>
            </div>

            <button v-on:click="searchInfo" class="o-b but-g f-r" id="basic-addon1">Buscar</button>
          </div>

        </div>
      </div>

      <div class="b-c">

        <div class="list">
          <div class="">
            <button v-if="appointments.length > 0" v-on:click="exportCSV" class="o-b but-r" id="basic-addon1">Exportar EXCEL</button>
            <p class="o-b">Reporte</p>
          </div>

        <div class="text-center m-top" v-if="appointments.length == 0">Sin resultados</div>
        <div class="text-center" v-if="appointments.length > 0">
          <table class="table table-light m-top">
            <thead>
              <tr>
                <th scope="col">Fecha</th>
                <th scope="col">Horario</th>
                <th scope="col">Código promocional</th>
                <th scope="col">Servicio</th>
                <th scope="col">Categoría</th>
                <th scope="col">Pago</th>
                <th scope="col">Estilista</th>
                <th scope="col">Cliente</th>
                <th scope="col">Estatus</th>
                <th scope="col">Comentarios</th>
                <th scope="col">Rating Servicio</th>
                <th scope="col">Rating Estilista</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(appointment, e) in appointments" :key="e">
                <td>{{appointment.date}}</td>
                <td>{{appointment.hour}}</td>
                <td>{{appointment.data.promocode ? appointment.data.promocode.code : ' - '}}
                <td>{{appointment.service.name}}</td>
                <td>{{appointment.service.category.name}}</td>
                <td>${{appointment.finalAmount}}</td>
                <td>{{appointment.professional.fullname}}</td>
                <td>{{appointment.client}}</td>
                <td>Finalizado</td>
                <td>{{appointment.commentServicio}}</td>
                <td v-if="typeof appointment.rating === 'undefined' "> - </td><td v-else> {{appointment.rating}}/5 </td>
                <td v-if="typeof appointment.ratingProfessional === 'undefined' "> - </td><td v-else> {{appointment.ratingProfessional}}/5 </td>
              </tr>
            </tbody>
          </table>
          <div><p class="amount">Monto total: ${{total}}</p></div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Side from "@/components/Side";
import Nav from "@/components/Nav";
import Appointment from "../parse/models/Appointment";
import Datepicker from 'vuejs-datepicker';
import { en, es } from 'vuejs-datepicker/dist/locale'
import User from '../parse/models/User'
import Service from '../parse/models/Service'
import Category from '../parse/models/Category'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import XLSX from 'xlsx';

export default {
  name: "Reports",
  components: {
    Datepicker,
    DateRangePicker
  },
  data() {
    return {
      errors: '',
      categories: [],
      services: [],
      appointments: [],
      stylists: [],
      en: en,
      es: es,
      datese: "",
      dI: "",
      dF: "",
      op: 0,
      diference: 0,
      professionalList: [],
      months: this.moment.months(),
      serviceSelected: "",
      categorySelected: "",
      stylistSelected: "",
      today: new Date(),
      autoUpdateInput: true,
      startDate: this.moment(),
      endDate: '',
      open: 'right',
      dateInvalid: 0,
      locale: {
        direction: 'ltr',
        format: 'dd/mm/yyyy', //format of the dates displayed
        separator: ' a ', //separator between the two ranges
        applyLabel: 'Aceptar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        fromLabel: 'Desde',
        toLabel: 'Hasta',
        customRangeLabel: 'Seleccionar rango',
        daysOfWeek: this.moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: this.moment.months(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
        maxDate: this.moment(),
        disabledDate(date) {
          return date > this.moment()
        }
      },
      dateRange: {
        startDate: this.moment(),
        endDate: this.moment(),
      },
      datePickerOptions: {
        disabledDate(date) {
          return date > this.moment()
        }
      }
    };
  },
  computed: {
    total() {
      return this.appointments.reduce((sum, appointment) => sum + parseInt(appointment.finalAmount), 0)
    }
  },
  async beforeMount() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0)

    var thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    var thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.range = {
      'Hoy': [today, today],
      'Mes en curso': [thisMonthStart, thisMonthEnd],
      'Anterior mes': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
    }

    this.categories = await Category.load()
    this.stylists = await User.loadStylelist()
    this.appointments = await Appointment.loadReport()
    this.services = await Service.load()
  },
  methods: {
    exportCSV() {
      let data = this.appointments.map(appointment => ({
        Fecha: appointment.date,
        Horario: appointment.hour,
        Código_promocional: appointment.data.promocode ? appointment.data.promocode.code : '-',
        Servicio: appointment.service.name,
        Categoría: appointment.service.category.name,
        Pago: appointment.finalAmount,
        Estilista: appointment.professional.fullname,
        Cliente: appointment.client,
        Email: appointment.user.email,
        Comentarios: appointment.commentServicio,
        Rating_Servicio: appointment.rating,
        Rating_Estilista: appointment.ratingProfessional
      }))

      const workbook = XLSX.utils.book_new()
      const filename = 'Reporte'
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(data), filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    onDateRangeChanged: function (picker) {
      this.dI = picker.startDate
      this.dF = picker.endDate

      let a = this.moment(picker.startDate);
      let b = this.moment(picker.endDate);

      let auxF = this.moment.duration(b.diff(a));
      this.diference = auxF.asDays();

      let z = this.moment()
      const auxFa = this.moment.duration(b.diff(z));
      const aass = auxFa.asDays();

      if (Math.sign(aass) >= 1) {

        this.dateInvalid = 1
        this.errors = 'Selecciona una fecha anterior al dia de hoy'
        return true;
      }

      this.errors = null
    },

    async searchInfo() {
      const stylist = this.stylistSelected

      if (stylist == "") {
        if (this.dateInvalid == 1) {
          this.errors = 'Selecciona una fecha anterior al día de hoy'
          return
        }

        if (this.dI == "" && this.dF == "") {
          this.errors = 'Selecciona un rango de fechas'
          return
        }
      }

      const category = this.categorySelected
      const service = this.serviceSelected
      const period = {
        'start': this.dI,
        'end': this.dF
      }

      this.errors = ''

      this.appointments = await Appointment.loadReportWithPameters(period, category, service, stylist)
    },
    searchweeksa(mJsDate) {
      var str = mJsDate.toLocaleString().substring(0, 3) +
        " number " + Math.ceil(mJsDate.date() / 7) +
        " of the month";
      return str;
    },
    checkIn(val) {

      if (this.op == 0) {
        this.dI = val;
      }

      if (this.op > 0) {
        this.dF = val;
        let a = this.moment(this.dI);
        let b = this.moment(this.dF);
        let auxF = this.moment.duration(b.diff(a));
        this.diference = auxF.asDays();
      }

      this.op += 1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.right {
  text-align: right;
  padding: 10px;
  font-size: 12px;
}

.daterangepicker {
  background: red;
}

.daterangepicker .openscenter {
  right: auto;
  left: 0;
  -webkit-transform: translate(0);
  transform: translate(0);
}

.min-h {
  height: 350px;
}

.amount {
  float: right;
  font-weight: 700;
  margin-bottom: 20px;
}
.m-top-i {
  margin: 3em 0 0 0;
}

.calendar > .my-datepicker_calendar {
  width: 100%;
  height: 130px;
}

.a-relative {
  position: relative;
}

.a-relative button {
  position: absolute;
  left: 0;
  bottom: 0;
}

.d-i {
  display: inline-block;
  margin-right: 20px;
}

.c-t-info {
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.c-t-info-h-active {
  height: auto;
  max-height: 600px;
}

/* USER INFO */
.img_user {
  width: 138px;
  height: 138px;
  border-radius: 70px;
  float: left;
  margin-right: 20px;
}

.info-u {
  display: inline;
}

.info-ac button {
  display: inline;
}

table tbody tr {
  background: #f3f3f3;
}

.but-r {
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-weight: 400;
  float: right;
  margin-bottom: 2em;
}

.but-r:hover {
  background: rgb(231, 76, 84);
}

.but-c {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 270px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
}

.but-c:hover {
  background: #14fc78;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 250px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.c-i-c-t {
  width: 200px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
  position: relative;
  min-width: 1280px;
  overflow: hidden;
}

.sub-t {
  font-size: 18px;
  display: inline-block;
  margin-left: 120px;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 10px;
  height: 40px;
  width: 100%;
  border-radius: 10px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  margin: 0 10px 0 0;
  font-weight: 600;
}

.but-g:hover {
  background: #14fc78;
}

.but-b {
  background: #000;
  color: #fff;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 10px;
}
.but-b:hover {
  background: rgb(27, 27, 27);
}

.btn-f {
  margin: 0 40px 0 20px;
}

.f-r {
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: 25px;
  margin-right: 25px;
}

.s-o {
  background: #f3f3f3;
  border: none;
  font-family: 'Open regular';
  font-size: 16px;
  padding: 5px;
  width: 200px;
}

.s-o option {
  padding: 5px;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}
.btn-actions {
  background: #f6f6f6;
  border: none;
}

.select-css {
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #444;
  line-height: 1.3;
  padding: 0.4em 1.4em 0.3em 0.8em;
  width: 400px;
  max-width: 100%;
  box-sizing: border-box;
  margin: 20px 0;
  border: none;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.03);
  border-radius: 0.3em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #f3f3f3;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
    linear-gradient(to bottom, #f3f3f3 0%, #f3f3f3 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}

/*
* Error 
*/

.error {
  color: red;
  font-size: 12px;
}

.error ul {
  padding: 0;
  list-style: none;
}
</style>
